@use '../shared-styles' as *;
@use '../../design-tokens/typography/typography' as *;

@layer design-system {
  .highLowChartRoot {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .rootSvg { @include root-svg; }
  .axisLine { @include axis-line; }
  .axisText { @include typography-v2-body-xs; fill:var(--text-soft); }
  .circle { @include circle; }
  .animatedGroup { @include animated-group; }

  .rect { @include rect; }
  .rectProfit { fill: var(--viz-bullish); }

  .line { @include line; }
  .lineProfit { stroke: var(--viz-bullish); }

  .areaFill { @include area-fill; }
  .areaFillProfit { fill: var(--viz-bullish); }
}
